import {
  AcuerdoRequest,
  ICEEntrada,
  ICEIndicacionesAB,
  ICETema,
  ICNuevoTema,
} from "../../../interfaces/acuerdo";
import { IAcuerdo } from "../../../interfaces/acuerdos";
import { INuevaEntrada } from "../../../interfaces/entradas";
import { IDetalleTema, IIndicacionAB } from "../../../interfaces/temas";
import * as moment from "moment";

export const dtoDetalleTema = (
  acuerdoActual: IAcuerdo,
  temas: IDetalleTema[]
): AcuerdoRequest => {
  const temasAcuerdo = temas.map((tema: IDetalleTema): ICETema => {
    const  esImpreso=!!tema.esImpreso && tema.esImpreso !== 0 ? tema.esImpreso : false;
    const esConfidencial = tema.esConfidencial && tema.esConfidencial !== 0 ? tema.esConfidencial: false;
    const esAprobado =!!tema.esAprobado && tema.esAprobado !== 0 ? tema.esAprobado : false;

    const tem: ICETema = {
      accionTerminar: false,
      acciones: "",
      categorias: categorias,
      categorizacion: tema.categorizacion,
      descripcionTema: stripHtml(tema.descripcionTema_html),
      descripcionTema_html: tema.descripcionTema_html,
      deshabilitar: true,
      disabledIndicacion: true,
      edoTema: tema.edoTema,
      entradaSelected: false,
      entradas: mapentradas(tema.entradas) ?? [],
      esAprobado,
      esConfidencial,
      esImpreso,
      esResponsable: false,
      fechaAcuerdo: formatToISOWithAdjustedTime(tema.fechaAcuerdo),
      id: tema.id,
      idAcuerdo: acuerdoActual.idFE,
      id_categoria: tema.id_categoria,
      indicacionAB: "",
      indicacionesAB: mapeaIndicaciones(tema.indicacionesAB) ?? [],
      indiceTema: tema.indiceTema,
      isDisabledGuardaEntrada: false,
      justificacion: null,
      nombreTema: tema.nombreTema,
      ocultar: false,
      respAnalista: tema.respAnalista,
      respCoordinador: tema.respCoordinador,
      respSupervisor: tema.respSupervisor,
      searchText: "",
      selectedItem: false,
      tipoTema: tema.tipoTema,
      verTema: tema.expanded ?? false,
      totalEntregables: 0,
      nuevoTema: tema.nuevoTema,
    };

    if (!tem.nuevoTema) {
      delete tem.nuevoTema;
    }
    if (tem.nuevoTema) {
      delete tem.accionTerminar;
      delete tem.acciones;
      delete tem.deshabilitar;
      delete tem.justificacion;
      delete tem.ocultar;
      delete tem.totalEntregables;
      tem.nuevoTema = true;
      tem.edoTema = 1;
      tem.esAprobado = tema.esAprobado;
      tem.id = "";
      tem.esImpreso = tema.esImpreso;
      tem.esAprobado = tema.esAprobado;
    }

    return tem;
  });

  return {
    acuerdo: {
      idAcuerdo: acuerdoActual.idFE,
      fechaAcuerdo: formatToISOWithAdjustedTime(acuerdoActual.fechaAcuerdo),
      esRealizado: acuerdoActual.esRealizado,
      observaciones: acuerdoActual.observaciones ?? "",
      cambioObservacion: acuerdoActual.cambioObservacion ?? false,
    },
    temas: [...temasAcuerdo],
  };
};

export const dtoNuevoTema = (temas: IDetalleTema[]): ICNuevoTema[] => {
  const temasAcuerdo = temas
    .filter((tema: IDetalleTema) => tema.nuevoTema) // Filtrar los temas con nuevoTema === true
    .map((tema: IDetalleTema): ICNuevoTema => {
      return {
        nombreUsuario: tema.nombreUsuario ?? "",
        fechaAcuerdo: formatToISOWithAdjustedTime(tema.fechaAcuerdo),
        nombreTema: tema.nombreTema,
        descripcionTema: stripHtml(tema.descripcionTema_html),
        nombreAnalista: tema.nombreAnalista ?? "",
        nombreSupervisor: tema.nombreSupervisor ?? "",
        nombreCoordinador: tema.nombreCoordinador ?? "",
        id_categorizacion: tema.id_categorizacion ?? "",
      };
    });
  return temasAcuerdo;
};

export const mapentradas = (entradas: INuevaEntrada[]): ICEEntrada[] => {
  const ent = entradas.map((entrada: INuevaEntrada,index): ICEEntrada => {
    // Crear una copia del objeto sin la propiedad `id_entrada`
    const { id_entrada, ...restoEntrada } = entrada;

    return {
      ...restoEntrada, // Utilizar la copia sin `id_entrada`
      puedeVer: false,
     // mostrarTitulos: false,
     // originalName: "",
     // esFront: true,
      entregables: mapeaEntregables(entrada.entregables),
      archivos: mapeaArchivos(entrada.archivos),
      indiceEntrada:index
      //mmapear archivos
    };
  });
  return ent;
};

export const mapeaIndicaciones = (
  indicaciones: IIndicacionAB[]
): ICEIndicacionesAB[] => {
  const indi = indicaciones.map((indicacion): ICEIndicacionesAB => {
    return {
      ...indicacion,
      idIndicacion: indicacion.idIndicacion ?? "",
    };
  });

  return indi;
};
export const mapeaArchivos = (archivos: any[]): any[] => {
  console.log("archiivos", archivos);
  
  const fechaActual = new Date().toISOString();
  console.log(fechaActual);

  return archivos.map(
    (
      {
        banEsActivo,
        id_entrada,
        metadata,
        nombre_archivo,
        ts_actualiza_audit,
        ts_alta_audit,
        usuario_audit,
        indice,
        indiceEnTema
      },
      index
    ) => ({
      banEsActivo,
      id_entrada,
      indice,
      indiceEnTema,
      metadata,
      nombre_archivo,
      ts_actualiza_audit,
      ts_alta_audit,
      usuario_audit,
      url: "",
    })
  );
};

export const mapeaEntregables = (entregables: any[]): any[] => {
  console.log("mapeaEntregables", entregables);
  
  return entregables.map(
    (
      {
        edoEntregable,
        id_entrada,
        id_entregable,
        nombreEntregable,
        urlEntregable,
        idEntrada,
        idEntregable,
      },
      index
    ) => ({
      edoEntregable,
      idEntrada: id_entrada ?? idEntrada,
      idEntregable: id_entregable ?? idEntregable,
      indice: index,
      nombreEntregable,
      urlEntregable,
    })
  );
};
export const stripHtml = (html: string) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
export const validateCamposObligatorios = (temas: ICETema[]): boolean => {
  if (temas.length === 0) {
    return true;
  }

  return temas.every((tema) => {
    const camposObligatorios = [
      tema.categorizacion,
      tema.nombreTema,
      tema.descripcionTema,
      tema.descripcionTema_html,
      tema.respCoordinador,
    ];

    const camposNumericos = [
      typeof tema.tipoTema === "number" && tema.tipoTema !== 0,
      typeof tema.edoTema === "number",
      typeof tema.id_categoria === "number" && tema.id_categoria !== 0,
    ];
    const camposDefinidos = [
      tema.esConfidencial !== undefined,
      tema.esAprobado !== undefined,
      tema.esImpreso !== undefined,
    ];

    const camposConfidenciales =
      tema.esConfidencial || tema.esConfidencial == 1
        ? 
          tema.respCoordinador?.trim() !== ""
        :
          tema.respAnalista?.trim() !== "" &&
          tema.respSupervisor?.trim() !== "" &&
          tema.respCoordinador?.trim() !== "";

    return (
      camposObligatorios.every(Boolean) &&
      camposNumericos.every(Boolean) &&
      camposDefinidos.every(Boolean) &&
      camposConfidenciales
    );
  });
};

export const validateCamposNuevoTema = (temas: ICNuevoTema[]): boolean => {
  console.log("temas", temas);
  
  if (temas.length == 0) {
    return true;
  }
 
  return temas.every((tema) => {
    
    return (
      tema.descripcionTema.trim() !== "" &&
      tema.fechaAcuerdo.trim() !== "" &&
      tema.id_categorizacion.trim() !== "" &&
      // tema.nombreAnalista.trim() !== "" &&
      // tema.nombreSupervisor.trim() !== "" &&
      tema.nombreCoordinador.trim() !== "" &&
      tema.nombreTema.trim() !== "" &&
      tema.nombreUsuario.trim() !== ""
    );
  });
};

export const accionesAcuerdos = (tipoAcuerdo: number) => {
  const esHistorico = tipoAcuerdo == 3;

  const accciones = [
    {
      id: 1,
      label: "Aplazar",
      disabled: esHistorico,
    },
    {
      id: 2,
      label: "Mover",
      disabled: false,
    },
    {
      id: 3,
      label: "Quitar",
      disabled: esHistorico,
    },
  ];
  if (esHistorico) {
    accciones.push({
      id: 4,
      label: "Terminar",
      disabled: false,
    });
  }
  return accciones;
};

export const formatToISOWithAdjustedTime = (dateString: string): string => {
  const utcDate = moment.utc(dateString);
  const adjustedDate = utcDate.hour(6).minute(0).second(0).millisecond(0);
  return adjustedDate.toISOString();
};

export const categorias= [
                {
                    "descripcion": "C",
                    "descripcionCompleta": "Corporativo",
                    "enabled": true,
                    "id": "-KcOsYIkmr2FHgi4ubym"
                },
                {
                    "descripcion": "CC",
                    "descripcionCompleta": "Corporativo Confidencial",
                    "enabled": false,
                    "id": "-KcOsYIoTX3wdcK4DMjF"
                },
                {
                    "descripcion": "P",
                    "descripcionCompleta": "Personal",
                    "enabled": false,
                    "id": "-KcOsYIprL1TVCF2uyaO"
                },
                {
                    "descripcion": "PC",
                    "descripcionCompleta": "Personal Confidencial",
                    "enabled": false,
                    "id": "-KdfegAIz9pHjb6ak32K"
                }
            ];
